<template>
  <div class="loading">
    <hollow-dots-spinner
      class="loading__spinner"
      :animation-duration="2000"
      :dot-size="20"
      :dots-num="3"
      :color="'#ffd000'"
    />
  </div>
</template>

<script setup lang="ts">
import HollowDotsSpinner from './HollowDotsSpinner.vue'
</script>
